/**
 * Use this to generate a unique ID
 * @returns A unique ID
 */
export const createUniqueId = () =>
  (Date.now().toString(32) + Math.random().toString(16)).replace(/\./g, '');
